module.exports = __webpack_public_path__ + "fa-solid-900.ttf?b87b9ba532ace76ae9f6edfe9f72ded2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.ttf
// module id = 47
// module chunks = 0